

export const V = "rgb(73, 132, 40)";
export const A = 'rgb(210, 208, 42)';
export const R = 'rgb(153, 41, 41)';
export const P = "#c249c0";
export const B = "#195691";